import get from 'lodash/get'

import Http from '../../../shared/http'

export const onSubmit = (referralsPath, setInviting, setInviteSent, setError, setEmail) => async (values) => {
  const email = get(values, 'email')
  const name = get(values, 'name')
  const params = {
    referral: {
      email,
      name
    }
  }

  try {
    setInviting(true)
    setEmail(email)
    const response = await Http.request(referralsPath, 'POST', JSON.stringify(params))
    if (response.ok) {
      setInviting(false)
      setInviteSent(true)
      setError(false)
    } else {
      setInviting(false)
      setError(true)
    }
  } catch {
    setInviting(false)
    setError(true)
  }
}
